export default __webpack_public_path__ + "static/media/fruit.9d107a19.png";